import React from 'react'
import moment from 'moment'
import { withBlogPosts } from '../../providers/Blog'
import { 
  BlogItemLink, 
  Wrapper,
  BlogItemTitle,
  BlogItemCategoryList,
  BlogItemCategoryTimeStamp,
  BlogItemMeta,
} from './styles'


class Blog extends React.Component {
  componentDidMount() {
    if (!this.props.blog.posts.length || this.props.blog.posts.length <= 1) {
      this.props.blog.actions.fetchAll()
    }
  }
  render() {
    if (this.props.blog.posts.length === 0) {
      return (
        <Wrapper>
          Sorry, could not find any posts.
        </Wrapper>
      )
    }
    return ( 
      <Wrapper>
      {this.props.blog.posts && this.props.blog.posts.map(({ fields }, idx) => 
        <BlogItemLink to={`/blog/${fields.slug}`} key={idx}>
          <BlogItemMeta>
            <BlogItemCategoryTimeStamp>
              {moment(fields.date).calendar(null, {
                sameDay: '[Today]',
                lastDay: '[Yesterday]',
                lastWeek: 'MMM Do, YYYY',
                sameElse: 'MMM Do, YYYY',
              })}
            </BlogItemCategoryTimeStamp>
            {fields.categories && (
              <BlogItemCategoryList>
                {
                  fields.categories.join(', ')
                }
              </BlogItemCategoryList>
            )}
          </BlogItemMeta>

          <BlogItemTitle>{fields.title}</BlogItemTitle>
        </BlogItemLink>
      )}
      </Wrapper>
    )
  }
}

export default withBlogPosts(Blog)


// WEBPACK FOOTER //
// ./src/pages/Blog/index.js